import { parseDate } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { CheckIcon } from "@radix-ui/react-icons";
import { ColumnDef } from "@tanstack/react-table";
import { Tables } from "@/gen/tableNames/tables";

export type S3PdfPageSelection = {
  id: number;
  client: string | null;
  page_name: string | null;
  tableau_view: string | null;
  tableau_workbook_id: string | null;
  pdf_report_display: boolean | null;
  created_at: string;
};

export const columns: ColumnDef<S3PdfPageSelection>[] = [
  {
    accessorKey: "id",
    header: () =>
      i18n.t(`${Tables.S3_PDF_PAGE_SELECTION}.columns.id`, {
        ns: "tables",
        defaultValue: "ID",
      }),
  },
  {
    accessorKey: "client",
    header: () =>
      i18n.t(`${Tables.S3_PDF_PAGE_SELECTION}.columns.client`, {
        ns: "tables",
        defaultValue: "Client",
      }),
  },
  {
    accessorKey: "page_name",
    header: () =>
      i18n.t(`${Tables.S3_PDF_PAGE_SELECTION}.columns.page_name`, {
        ns: "tables",
        defaultValue: "Page name",
      }),
  },
  {
    accessorKey: "tableau_view",
    header: () =>
      i18n.t(`${Tables.S3_PDF_PAGE_SELECTION}.columns.tableau_view`, {
        ns: "tables",
        defaultValue: "Tableau view",
      }),
  },
  {
    accessorKey: "tableau_workbook_id",
    header: () =>
      i18n.t(`${Tables.S3_PDF_PAGE_SELECTION}.columns.tableau_workbook_id`, {
        ns: "tables",
        defaultValue: "Tableau workbook ID",
      }),
  },
  {
    accessorKey: "pdf_report_display",
    header: () =>
      i18n.t(`${Tables.S3_PDF_PAGE_SELECTION}.columns.pdf_report_display`, {
        ns: "tables",
        defaultValue: "PDF report display",
      }),
    cell: ({ getValue }) =>
      getValue() && (
        <div className="flex justify-center pr-12">
          <CheckIcon />
        </div>
      ),
  },
  {
    accessorKey: "created_at",
    header: () =>
      i18n.t(`${Tables.S3_PDF_PAGE_SELECTION}.columns.created_at`, {
        ns: "tables",
        defaultValue: "Created at",
      }),
    cell: ({ row }) => {
      return parseDate(row.getValue("created_at"));
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
